import Echo from 'laravel-echo';
import {useDispatch, useSelector} from "react-redux";
import {onOrdersLoad, onOrdersPendingLoad, onOrdersUpdatesLoad} from "./Orders/actions";
import { useEffect } from "react";
window.Pusher = require('pusher-js');

const AudioTag = ({url}) => (
    <div>
        <audio className="audio-element">
            <source src={url} />
        </audio>
    </div>
)

const WsPush = () => {
    const dispatch = useDispatch();
    const url = '/media/alert3.mp3';

    useEffect(() => {
        window.Echo = new Echo({
            broadcaster: 'pusher',
            key: 'cheqit',
            wsHost: window.location.hostname,
            wsPort: 6001,
            forceTLS: false
        })
    },[]);

    useEffect(() => {

        if (typeof chainId !== "undefined" && chainId) {
            window.Echo.leave(`orders.${chainId}`)
            window.Echo.leave(`orders.${chainId}.staff`)
            window.Echo.leave(`orders.${chainId}.kitchen`)
            window.Echo.leave(`orders.${chainId}.bar`)

            //staff notifications
            if (userRoleId === 3) {
                window.Echo
                    .private(`orders.${chainId}.staff`)
                    .listen('OrderPending', function(event) {
                        dispatch(onOrdersPendingLoad(event.order, 'OrderPending'))
                    })
                    .listen('OrderConfirmed', function(event) {
                        dispatch(onOrdersUpdatesLoad(event.order, 'OrderConfirmedItems'))
                    })
                    .listen('OrderConfirmedItems', function(event) {
                        dispatch(onOrdersUpdatesLoad(event.order, 'OrderConfirmedItems'))
                    })
                    .listen('OrderCompleted', function(event) {
                        dispatch(onOrdersLoad())
                    })
                    .listen('OrderCanceled', function(event) {
                        dispatch(onOrdersLoad())
                    })
                    ;
            }

            //kitchen notifications
            else if (userRoleId === 4) {
                window.Echo
                    .private(`orders.${chainId}.kitchen`)
                    .listen('OrderConfirmed', function(event) {
                        dispatch(onOrdersUpdatesLoad(event.order, 'OrderConfirmed'))
                    })
                    .listen('OrderConfirmedItems', function(event) {
                        dispatch(onOrdersLoad())
                    })
                    .listen('OrderCanceled', function(event) {
                        dispatch(onOrdersLoad())
                    })
                    .listen('OrderCompleted', function(event) {
                        dispatch(onOrdersLoad())
                    })
                    .listen('OrderReady', function(event) {
                        dispatch(onOrdersLoad())
                    })
            }

            //bar notifications
            else if (userRoleId === 5) {
                window.Echo
                    .private(`orders.${chainId}.bar`)
                    .listen('OrderConfirmed', function(event) {
                        dispatch(onOrdersUpdatesLoad(event.order, 'OrderConfirmed'))
                    })
                    .listen('OrderConfirmedItems', function(event) {
                        dispatch(onOrdersLoad())
                    })
                    .listen('OrderCanceled', function(event) {
                        dispatch(onOrdersLoad())
                    })
                    .listen('OrderCompleted', function(event) {
                        dispatch(onOrdersLoad())
                    })
                    .listen('OrderReady', function(event) {
                        dispatch(onOrdersLoad())
                    })
            }

            else{
                window.Echo
                    .private(`orders.${chainId}`)
                    .listen('OrderPending', function(event) {
                        dispatch(onOrdersPendingLoad(event.order, 'OrderPending2'))
                    })
            }

        }
    }, [])

    return (
        <AudioTag url={url} />
    );
}

export default WsPush;
